import { styled } from '@attentive-platform/stem-ui';

export const FormContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  alignItems: 'center'
}));

export const StyledBreakWordContainer = styled('div')(() => ({
  wordBreak: 'break-word' /* Standard */,
  overflowWrap: 'break-word',
  width: '100%'
}));

export const InfoText = styled('div')(() => ({
  padding: '10px 14px',
  borderRadius: '4px',
  margin: '10px 0',
  borderLeft: '3px solid #4a5568',
  backgroundColor: '#f7fafc'
}));
